<template>
  <div class="home flex flex-col lg:flex-wrap w-full h-full overflow-hidden">
    <!-- notification popup -->
    <notification-popup />

    <!-- menu component -->
    <route-menu v-if="sterfietsroutesExtraData && map" :map="map" :data="sterfietsroutesExtraData" />

    <!-- container left -->
    <div class="relative w-full lg:h-full lg:w-2/5 2xl:w-1/3 3xl:w-1/4 p-4 lg:pb-16 flex flex-col overflow-y">
      <div class="w-full">
        <a href="https://denhaagfietst.nl" target="_blank">
          <svg class="w-40 lg:w-60 mt- lg:mt-8 m-auto" viewBox="0 0 680 201" xml:space="preserve">
            <path fill="#000"
              d="M199.5 66.6c-6.5 0-12.7-.3-18.4-.5V4.2c4.9-.3 12.8-.6 21.2-.6 18.7 0 31.1 8.1 31.1 30.2-.1 21.3-13.7 32.8-33.9 32.8zm1.8-50.9c-2.4 0-4.3 0-5.9.2v38c1.2.2 3.1.4 5.3.4 9.9 0 17.2-6.1 17.2-19.3.1-11.8-3.7-19.3-16.6-19.3zM280.4 46.9h-27.2c.1 6 3.2 9.4 11.3 9.4 4.4 0 9-.9 13.4-2.7l1.4 10.5c-5.2 1.9-11.5 3-17.1 3-14.9 0-23.2-7.3-23.2-23.4 0-13.8 8.3-24.4 22.4-24.4 13.7 0 19.5 8.7 19.5 19.8.1 2.3-.1 5.5-.5 7.8zm-19.7-17.3c-4 0-7 3.2-7.5 8h13.9c.2-5.3-2.3-8-6.4-8zM320.2 66.1V37c0-3.7-1-5.9-4.2-5.9-4.9 0-9 6.2-9 12.8v22.2h-14.1V31c-2.2-.4-5.3-.7-8-.9v-9c6.7-.7 14.3-1.1 21.1-.8 0 1.8-.1 5.1-.5 7.3l.2.1c2.8-4.8 7.8-8.3 15.1-8.3 10.2 0 13.6 6.6 13.6 14.6v32.2l-14.2-.1zM402.4 66.1V40.3h-22.8v25.9h-14.4V4h14.4v23.9h22.8V4h14.4v62.2c0-.1-14.4-.1-14.4-.1zM452.3 66.2c0-2.3 0-4.7.4-7h-.1c-2.2 4.8-7.6 7.9-14 7.9-8.8 0-13.4-5.3-13.4-12.7 0-11.6 11.2-17 25.8-17v-1.7c0-3.8-2.1-5.6-8.2-5.6-4 0-9.5 1.3-13.2 3.1l-1.4-11.4c4.7-1.5 11-2.7 16.6-2.7 15.8 0 20.3 5.9 20.3 16.4v19.9c2.2.4 5.3.7 8 .9v9c-6.6.8-14.1 1.2-20.8.9zm-1.3-20c-9.9 0-12.5 2.6-12.5 6 0 2.5 1.7 4.2 4.6 4.2 4.7 0 7.9-4.2 7.9-8.8v-1.4zM503.9 66.2c0-2.3 0-4.7.4-7h-.1c-2.2 4.8-7.6 7.9-14 7.9-8.8 0-13.4-5.3-13.4-12.7 0-11.6 11.2-17 25.8-17v-1.7c0-3.8-2.1-5.6-8.2-5.6-4 0-9.5 1.3-13.2 3.1l-1.4-11.4c4.7-1.5 11-2.7 16.6-2.7 15.8 0 20.3 5.9 20.3 16.4v19.9c2.2.4 5.3.7 8 .9v9c-6.6.8-14.2 1.2-20.8.9zm-1.3-20c-9.9 0-12.5 2.6-12.5 6 0 2.5 1.7 4.2 4.6 4.2 4.7 0 7.9-4.2 7.9-8.8v-1.4zM545.2 88.7c-5.2 0-10.2-.6-14.4-1.8l1.2-12.8c4.1 1.8 9.4 2.8 13.7 2.8 8.1 0 11.9-2.8 11.9-9.7v-1.7c0-1.7 0-3.4.5-5.7h-.2c-2.3 4.5-7 7.3-12.6 7.3-11 0-17-7.5-17-21.3 0-15 8.8-26.4 25.5-26.4 7.1 0 12.5.6 17.7 1.5v45.5c-.1 11.8-5.6 22.3-26.3 22.3zm12.2-57.6c-1.4-.3-2.9-.5-4.8-.5-5.4 0-9.6 3.5-9.6 13.7 0 7.6 2 11 6.3 11 4.8 0 8.1-5.3 8.1-13.3V31.1zM202.2 97.8c-12.5 0-24.5 4.6-33.8 13-9.7 8.8-15.6 21.1-16.4 34.1l9.1 3.1c0-11.6 4.9-22.7 13.5-30.5 7.6-6.9 17.4-10.6 27.6-10.6 22.7 0 41.1 18.4 41.1 41.1 0 22.7-18.4 41.1-41.1 41.1-21 0-36.9-12.3-51.9-28.2-.7-.7-1.4-1.5-2.1-2.2-4.2-4.6-8.4-9.4-12.6-14.2-9.4-10.8-18.9-21.8-29.6-30.4 17.8-31 31.3-59.6 31.5-60l3.2-6.8h-63l-3.4 9.5h51.2c-5 10.1-15.1 30.2-27.3 51.6C88.1 102 77 97.8 64.1 97.8c-27.7 0-50.3 22.6-50.3 50.3s22.6 50.3 50.3 50.3c26.7 0 48.6-20.9 50.2-47.2l-9.1-3.1c0 22.7-18.4 41.1-41.1 41.1-22.7 0-41.1-18.4-41.1-41.1 0-22.7 18.4-41.1 41.1-41.1 11 0 20.6 3.6 29.5 9.5-7.3 12.5-15.2 25-23.1 35.9l7.7 5.6c7.8-10.9 15.7-23.3 23-35.7 4.6 3.8 9.1 8.2 13.5 12.9 1.1 1.2 2.3 2.4 3.4 3.7 3.5 3.8 6.9 7.8 10.4 11.8 20.4 23.5 41.6 47.8 73.6 47.8 27.7 0 50.3-22.6 50.3-50.3s-22.5-50.4-50.2-50.4zM301.1 105.3v36.9h37.5v7.7h-37.5v47.3h-9.4V97.7h49v7.7c-.1 0-39.6 0-39.6-.1zM364.4 197.2v-65.8c-3.5-.6-8.5-1.2-12.8-1.5v-5c5.9-.7 15.2-1.3 22-1v73.3h-9.2zm4.6-90.4c-3.5 0-6.6-3-6.6-6.6s3.1-6.6 6.6-6.6c3.7 0 6.8 2.8 6.8 6.6 0 3.5-3.1 6.6-6.8 6.6zM454 157.7h-49.7c-.9 23.3 8.1 32.7 25.2 32.7 7.1 0 14.5-1.5 20.6-4.3l1.8 7.8c-6.9 2.8-15.3 4.4-24.5 4.4-21.4 0-33-11.8-33-37.6 0-21.8 11.8-38 31.7-38 20 0 28.2 13.7 28.2 29.3 0 1.1 0 3.2-.3 5.7zm-28.4-27.6c-10.9 0-18.7 7.8-20.6 20.6h39.5c.3-12.3-7-20.6-18.9-20.6zM497.1 198.2c-14.3 0-18.3-6.5-18.3-21.2v-45.7H462v-7.4h16.8V99.2l9.1-2.5V124h22.6v7.4H488v41.1c0 14 2.5 17.5 11.6 17.5 3.8 0 7.4-.4 10.2-1.2l1.3 8c-4 .8-9.4 1.4-14 1.4zM541.3 198.4c-5.6 0-11.8-.6-16.4-1.9l1.3-8.9c4.7 1.8 11.1 2.8 16.7 2.8 10.9 0 18.9-5.2 18.9-13.4 0-19-37.2-6.9-37.2-33.3 0-12.1 9.6-20.9 27.7-20.9 4.7 0 10.3.6 14.8 1.6l-1.2 8c-4.6-1.3-9.7-2.2-14.9-2.2-11.3 0-17 4.9-17 12.5 0 19 37.3 7.4 37.3 33 .1 12.5-11.1 22.7-30 22.7zM615.1 198.2c-14.3 0-18.3-6.5-18.3-21.2v-45.7H580v-7.4h16.8V99.2l9.1-2.5V124h22.6v7.4h-22.6v41.1c0 14 2.5 17.5 11.7 17.5 3.8 0 7.4-.4 10.2-1.2l1.3 8c-4 .8-9.5 1.4-14 1.4zM659.2 198.4c-4 0-7.1-3.1-7.1-7.1 0-3.8 3.1-6.9 7.1-6.9 4 0 7.1 3.1 7.1 6.9-.1 4-3.2 7.1-7.1 7.1zm3.8-23.9h-7.5l-1.9-80.4h11.2l-1.8 80.4z" />
          </svg>
        </a>

        <!-- selectbox component -->
        <div class="bg-white rounded shadow w-full mt-4 lg:mt-8">
          <select-route v-if="routes && sterfietsroutesExtraData" @showAllRoutes="showAllRoutes"
            :data="sterfietsroutesExtraData" />
        </div>
      </div>
      <!-- route info component -->
      <div
        class="route-info bg-white w-full top-0 left-0 h-full p-4 lg:p-0 lg:mt-4 lg:relative lg:flex lg:flex-1 lg:overflow-hidden lg:shadow"
        :class="[openInfo ? 'fixed z-20' : 'hidden']">
        <div v-if="sterfietsroutesInfo && sterfietsroutesExtraData" class="rounded w-full h-full overflow-y-scroll">
          <route-info v-if="sterfietsroutesExtraData && active !== null" :data="sterfietsroutesExtraData"
            @closeRouteInfo="openRouteInfo" />
          <sterfiets-info v-else :data="sterfietsroutesInfo" @closeRouteInfo="openRouteInfo" />
        </div>
      </div>
      <div class="hidden lg:block absolute left-4 bottom-5 text-sm">&copy; {{ year }} <a
          href="https://www.denhaagfietst.nl" target="_blank" title="ga naar denhaagfietst.nl"
          class="underline hover:no-underline">Den Haag Fietst!</a></div>
    </div>
    <!-- container right -->
    <div class="w-full lg:w-3/5 2xl:w-2/3 3xl:w-3/4 h-full relative">
      <div class="py-0 px-4 lg:p-8 lg:pl-0 w-full h-full map-holder relative">
        <div class="relative w-full h-full">
          <!-- info overlay -->
          <overlay />
          <!-- map component -->
          <div id="mapid" class="h-full relative z-10 rounded-t lg:rounded">
            <sterfiets-routes v-if="map && sterfietsroutesData && sterfietsroutesExtraData" :map="map"
              :sterfietsroutes="sterfietsroutesData" :data="sterfietsroutesExtraData" />
            <marker-cluster-group v-if="map" @setCluster="setCluster" :map="map" />
          </div>
          <div
            class="sm-nav absolute bottom-0 w-11/12 h-20 bg-white z-10 inset-x-1/2 transform -translate-x-1/2 rounded-t shadow lg:hidden">
            <div class="relative w-full h-full flex flex-wrap justify-center content-center" @click="openRouteInfo">
              <svg-inline class="w-2 absolute z-20 top-1" name="svg-arrow-white" />
              <div class="flex flex-col flex-wrap justify-center content-center pt-4">
                <svg-inline class="w-8 m-auto" name="svg-info" />
                <h4 class="text-sm font-bold">Sterfietsroutes informatie</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import axios from 'axios'
import L from "leaflet"
import 'leaflet-providers'
import RouteMenu from "@/components/Menu.vue"
import SelectRoute from "@/components/SelectRoute.vue"
import RouteInfo from "@/components/RouteInfo.vue"
import SterfietsInfo from "@/components/SterfietsInfo.vue"
import SterfietsRoutes from "@/components/SterfietsRoutes.vue"
import MarkerClusterGroup from "@/components/MarkerClusterGroup.vue"
import Overlay from "@/components/Overlay.vue"
import NotificationPopup from "@/components/NotificationPopup.vue"

export default {
  name: 'Home',
  components: {
    RouteMenu,
    SelectRoute,
    RouteInfo,
    SterfietsInfo,
    SterfietsRoutes,
    MarkerClusterGroup,
    Overlay,
    NotificationPopup
  },
  data: function () {
    return {
      map: null,
      markerLatLng: [47.313220, -1.319482],
      stallingenData: null,
      sterfietsroutesData: null,
      sterfietsroutesExtraData: null,
      sterfietsroutesInfo: null,
      markersData: null,
      cluster: null,
      openInfo: false,
      year: new Date().getFullYear(),
      popup: null
    }
  },
  computed: {
    ...mapState(['routes', 'active', 'stops', 'overlay', 'openOverlay']),
    articleImage() {
      return `${process.env.VUE_APP_API_URL}/${this.overlay.image.path}`
    }
  },
  created() {
    fetch(process.env.VUE_APP_API_URL + '/api/content/item/MapData', {
      headers: {
        'Content-Type': 'application/json',
        'api-key': process.env.VUE_APP_API_KEY
      }
    })
      .then(data => data.json())
      .then(data => {
        this.sterfietsroutesData = data.sterfietsroutes
      });
    fetch(process.env.VUE_APP_API_URL + '/api/content/item/Algemeen', {
      headers: {
        'Content-Type': 'application/json',
        'api-key': process.env.VUE_APP_API_KEY
      }
    })
      .then(data => data.json())
      .then(data => {
        this.sterfietsroutesInfo = { 'aantal': data.aantal, 'kilometers': data.kilometers, 'informatie': data.informatie, 'fietsers': data.fietsers }
        this.sterfietsroutesExtraData = data.sterfietsroutes
      });
  },
  mounted() {
    this.map = L.map('mapid', {
      zoomControl: true,
      zoom: 1,
      minZoom: 10,
      zoomAnimation: false,
      fadeAnimation: false,
      markerZoomAnimation: false,
      tap: false // fixes Safari issues with popups
    }).setView([52.078663, 4.288788], 13)
    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' + 'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      id: 'mapbox/light-v10',
      tileSize: 512,
      zoomOffset: -1
    }).addTo(this.map)
    L.tileLayer.provider('CartoDB.Positron', {
      apikey: process.env.VUE_APP_CARTO_API_KEY
    }).addTo(this.map)
    // this.map.attributionControl.setPosition('topright');

    this.map.on('zoomend', () => {
      if (this.map.getZoom() > 11) {
        this.stops.addTo(this.map)
        if (this.map.getZoom() > 13) {
          this.cluster.addTo(this.map)
        } else {
          this.cluster.remove()
        }
      }
      else {
        this.stops.remove()
      }
    });

    // this.popup = L.popup();
    // this.map.on('click', this.showPopup);    

  },
  methods: {
    async getData(name, file) {
      const { data } = await axios.get(`${process.env.VUE_APP_BASE_URL}/static/json/${file}`)
      this[name] = data
    },
    showPopup(e) {
      this.popup
        .setLatLng(e.latlng)
        .setContent("You clicked the map at " + e.latlng.toString())
        .openOn(this.map);
    },
    setCluster(layer) {
      this.cluster = layer
    },
    showAllRoutes() {
      for (let key in this.routes) {
        this.routes[key].forEach(function (item) {
          item.leaflet.setStyle({ "weight": 5, "opacity": 1 })
        });
      }
      this.map.closePopup()
      this.map.setView([52.078663, 4.288788], 13)
    },
    openRouteInfo() {
      this.openInfo = !this.openInfo
    }
  }
}
</script>

<style lang="scss">
.leaflet-container {
  font-family: 'TheMix C5';
  font-weight: normal;
}

.map-holder:after {
  content: '';
  @apply absolute bg-black w-full h-full top-32 left-32 z-0;
}

@screen lg {
  .route-info:after {
    content: '';
    @apply absolute h-2 bottom-0 left-0 rounded-b bg-blue-500 w-full z-10;
  }
}

.leaflet-popup-content {
  max-width: 250px;

  @screen lg {
    max-width: none;
  }
}

.leaflet-container .leaflet-popup-content a {
  @apply text-yellow;
}

.pb-ratio {
  overflow: hidden;
  padding-bottom: 56.25%;
}

.sm-nav:after {
  content: '';
  @apply absolute h-3.5 top-0 left-0 rounded-t bg-blue-500 w-full z-10;
}

.leaflet-control-container .leaflet-control-attribution {
  max-width: 60% !important;
}
</style>